import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-553b01dd")

_pushScopeId("data-v-553b01dd")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "row w-100 g-3 align-items-center" }
const _hoisted_4 = { class: "col-md-2" }
const _hoisted_5 = { class: "col-md-2" }
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = { class: "col-md-2" }
const _hoisted_10 = { class: "col-12 text-end" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sync-alt" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_13 = {
  key: 1,
  class: "text-gray-400 fs-7"
}
const _hoisted_14 = {
  key: 2,
  class: "text-gray-400 fs-7"
}
const _hoisted_15 = {
  key: 0,
  class: "text-gray-400 ms-2"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "text-gray-400 fs-7"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-redo-alt" }, null, -1)
const _hoisted_20 = {
  class: "modal fade",
  id: "wms_log_modal",
  tabindex: -1,
  "aria-hidden": "true"
}
const _hoisted_21 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modal-header" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-1" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
  ])
], -1)
const _hoisted_26 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_27 = { class: "d-flex flex-wrap gap-6 mb-6 fs-6" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "text-gray-400 me-2" }, "HTTP", -1)
const _hoisted_30 = { class: "text-gray-400 me-2" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "text-gray-400 me-2" }
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { class: "text-gray-400 me-2" }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { class: "text-gray-400 me-2" }
const _hoisted_37 = { key: 4 }
const _hoisted_38 = { class: "text-gray-400 me-2" }
const _hoisted_39 = { class: "mb-6 text-break" }
const _hoisted_40 = { class: "fw-bold me-2" }
const _hoisted_41 = {
  key: 0,
  class: "alert alert-danger text-break"
}
const _hoisted_42 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_43 = { class: "fw-bolder mb-3" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = {
  key: 2,
  class: "mb-6"
}
const _hoisted_47 = { class: "fw-bolder mb-3" }
const _hoisted_48 = { class: "bg-light rounded p-5 fs-7 mb-0 wms-log-body" }
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-lg-6 mb-6" }
const _hoisted_51 = { class: "fw-bolder mb-3" }
const _hoisted_52 = { class: "fs-7 fw-bold text-gray-400 mb-2" }
const _hoisted_53 = { class: "bg-light rounded p-5 fs-7 mb-4 wms-log-headers" }
const _hoisted_54 = { class: "bg-light rounded p-5 fs-7 mb-0 wms-log-body" }
const _hoisted_55 = { class: "col-lg-6 mb-6" }
const _hoisted_56 = { class: "fw-bolder mb-3" }
const _hoisted_57 = { class: "bg-light rounded p-5 fs-7 mb-0 wms-log-body" }
const _hoisted_58 = {
  key: 1,
  class: "modal-footer"
}
const _hoisted_59 = /*#__PURE__*/_createVNode("i", { class: "fas fa-redo-alt" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.filters.direction,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.direction = $event)),
            clearable: "",
            placeholder: _ctx.$t('message.WMS_DIRECTION'),
            class: "w-100"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.directions, (option) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: option.value,
                  label: _ctx.$t(option.label),
                  value: option.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.filters.entity,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters.entity = $event)),
            clearable: "",
            placeholder: _ctx.$t('message.WMS_ENTITY'),
            class: "w-100"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.entities, (option) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: option.value,
                  label: _ctx.$t(option.label),
                  value: option.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.filters.status,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters.status = $event)),
            clearable: "",
            placeholder: _ctx.$t('message.STATUS'),
            class: "w-100"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statuses, (option) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: option,
                  label: _ctx.$t(`message.WMS_LOG_STATUS_${option.toUpperCase()}`),
                  value: option
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.filters.search,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filters.search = $event)),
            clearable: "",
            placeholder: _ctx.$t('message.ENTER_KEY_TO_SEARCH'),
            onKeyup: _withKeys(_ctx.search, ["enter"])
          }, null, 8, ["modelValue", "placeholder", "onKeyup"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.filters.date_from,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters.date_from = $event)),
            type: "date",
            class: "w-100",
            placeholder: _ctx.$t('message.START_DATE'),
            format: "DD-MM-YYYY",
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.filters.date_to,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filters.date_to = $event)),
            type: "date",
            class: "w-100",
            placeholder: _ctx.$t('message.END_DATE'),
            format: "DD-MM-YYYY",
            "value-format": "YYYY-MM-DD"
          }, null, 8, ["modelValue", "placeholder"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("button", {
            type: "button",
            class: "btn btn-light me-3",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
          }, _toDisplayString(_ctx.$t('message.RESET')), 1),
          _createVNode("button", {
            type: "button",
            class: "btn btn-light me-3",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getLogs(_ctx.pagination.current_page || 1)))
          }, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('message.REFRESH')), 1)
          ]),
          _createVNode("button", {
            type: "button",
            class: "btn btn-custom",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
          }, _toDisplayString(_ctx.$t('message.SEARCH')), 1)
        ])
      ])
    ]),
    _createVNode(_component_Table, {
      columns: _ctx.columns,
      rows: _ctx.logs,
      pagination: _ctx.pagination,
      onHandleCurrentChange: _ctx.getLogs,
      padding: 5,
      loading: _ctx.loader
    }, {
      "cell-created_at": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(_ctx.formatDate(item.created_at)), 1)
      ]),
      "cell-direction": _withId(({ row: item }) => [
        _createVNode("span", {
          class: `badge badge-light-${item.direction == 'in' ? 'info' : 'primary'}`
        }, _toDisplayString(_ctx.$t(`message.WMS_DIRECTION_${item.direction.toUpperCase()}`)), 3)
      ]),
      "cell-entity": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(_ctx.entityLabel(item.entity)) + " ", 1),
        (item.action == 'delete')
          ? (_openBlock(), _createBlock("span", _hoisted_12, "(" + _toDisplayString(_ctx.$t('message.WMS_ACTION_DELETE')) + ")", 1))
          : _createCommentVNode("", true),
        (item.order_id)
          ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('message.ORDER_ID')) + ": #" + _toDisplayString(item.order_id), 1))
          : (item.records)
            ? (_openBlock(), _createBlock("div", _hoisted_14, _toDisplayString(item.records) + " " + _toDisplayString(_ctx.$t('message.RECORDS')), 1))
            : _createCommentVNode("", true)
      ]),
      "cell-status": _withId(({ row: item }) => [
        _createVNode("span", {
          class: `badge badge-light-${_ctx.statusColor(item.status)}`
        }, _toDisplayString(_ctx.$t(`message.WMS_LOG_STATUS_${item.status.toUpperCase()}`)), 3),
        (item.response_status)
          ? (_openBlock(), _createBlock("span", _hoisted_15, "HTTP " + _toDisplayString(item.response_status), 1))
          : _createCommentVNode("", true),
        (item.error)
          ? (_openBlock(), _createBlock("div", {
              key: 1,
              class: "text-danger fs-7 text-truncate wms-log-error",
              title: item.error
            }, _toDisplayString(item.error), 9, ["title"]))
          : _createCommentVNode("", true)
      ]),
      "cell-attempt": _withId(({ row: item }) => [
        (item.resent_by)
          ? (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('message.WMS_RESEND')) + " · " + _toDisplayString(item.resent_by), 1))
          : (item.attempt != null)
            ? (_openBlock(), _createBlock("span", _hoisted_17, _toDisplayString(item.attempt), 1))
            : _createCommentVNode("", true),
        (item.duration_ms != null)
          ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(item.duration_ms) + " ms", 1))
          : _createCommentVNode("", true)
      ]),
      "cell-actions": _withId(({ row: item }) => [
        _createVNode("button", {
          class: "btn btn-sm btn-light me-2",
          type: "button",
          onClick: ($event: any) => (_ctx.openLog(item.id))
        }, _toDisplayString(_ctx.$t('message.VIEW')), 9, ["onClick"]),
        (item.can_resend)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "btn btn-sm btn-light-warning",
              type: "button",
              disabled: !_ctx.wmsManagesProducts,
              title: _ctx.wmsManagesProducts ? '' : _ctx.$t('message.WMS_SYNC_DISABLED_WMS_OFF'),
              onClick: ($event: any) => (_ctx.resend(item.id))
            }, [
              _hoisted_19,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.WMS_RESEND')), 1)
            ], 8, ["disabled", "title", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"]),
    _createVNode("div", _hoisted_20, [
      _createVNode("div", _hoisted_21, [
        _createVNode("div", _hoisted_22, [
          _createVNode("div", _hoisted_23, [
            (_ctx.log)
              ? (_openBlock(), _createBlock("h2", _hoisted_24, "#" + _toDisplayString(_ctx.log.id) + " · " + _toDisplayString(_ctx.$t(`message.WMS_DIRECTION_${_ctx.log.direction.toUpperCase()}`)) + " · " + _toDisplayString(_ctx.entityLabel(_ctx.log.entity)), 1))
              : _createCommentVNode("", true),
            _hoisted_25
          ]),
          (_ctx.log)
            ? (_openBlock(), _createBlock("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", null, [
                    _createVNode("span", {
                      class: `badge badge-light-${_ctx.statusColor(_ctx.log.status)}`
                    }, _toDisplayString(_ctx.$t(`message.WMS_LOG_STATUS_${_ctx.log.status.toUpperCase()}`)), 3)
                  ]),
                  (_ctx.log.response_status)
                    ? (_openBlock(), _createBlock("div", _hoisted_28, [
                        _hoisted_29,
                        _createTextVNode(_toDisplayString(_ctx.log.response_status), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", null, [
                    _createVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('message.CREATED_AT')), 1),
                    _createTextVNode(_toDisplayString(_ctx.formatDate(_ctx.log.created_at)), 1)
                  ]),
                  (_ctx.log.duration_ms != null)
                    ? (_openBlock(), _createBlock("div", _hoisted_31, [
                        _createVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('message.WMS_DURATION')), 1),
                        _createTextVNode(_toDisplayString(_ctx.log.duration_ms) + " ms ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.log.order_id)
                    ? (_openBlock(), _createBlock("div", _hoisted_33, [
                        _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('message.ORDER_ID')), 1),
                        _createTextVNode("#" + _toDisplayString(_ctx.log.order_id), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.log.attempt != null)
                    ? (_openBlock(), _createBlock("div", _hoisted_35, [
                        _createVNode("span", _hoisted_36, _toDisplayString(_ctx.$t('message.WMS_ATTEMPT')), 1),
                        _createTextVNode(_toDisplayString(_ctx.log.attempt), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.log.resent_by)
                    ? (_openBlock(), _createBlock("div", _hoisted_37, [
                        _createVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('message.WMS_RESEND')), 1),
                        _createTextVNode(_toDisplayString(_ctx.log.resent_by), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_39, [
                  _createVNode("span", _hoisted_40, _toDisplayString(_ctx.log.method), 1),
                  _createTextVNode(_toDisplayString(_ctx.log.url), 1)
                ]),
                (_ctx.log.error)
                  ? (_openBlock(), _createBlock("div", _hoisted_41, _toDisplayString(_ctx.log.error), 1))
                  : _createCommentVNode("", true),
                (_ctx.log.attempts?.length > 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_42, [
                      _createVNode("h4", _hoisted_43, _toDisplayString(_ctx.$t('message.WMS_ATTEMPTS')), 1),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.log.attempts, (attempt) => {
                        return (_openBlock(), _createBlock("div", {
                          key: attempt.id,
                          class: "fs-7 mb-1"
                        }, [
                          _createVNode("a", {
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.openLog(attempt.id)), ["prevent"]),
                            class: { 'fw-bolder': attempt.id == _ctx.log.id }
                          }, "#" + _toDisplayString(attempt.id), 11, ["onClick"]),
                          _createTextVNode(" · " + _toDisplayString(_ctx.formatDate(attempt.created_at)) + " · ", 1),
                          _createVNode("span", {
                            class: `text-${_ctx.statusColor(attempt.status)}`
                          }, _toDisplayString(_ctx.$t(`message.WMS_LOG_STATUS_${attempt.status.toUpperCase()}`)), 3),
                          (attempt.response_status)
                            ? (_openBlock(), _createBlock("span", _hoisted_44, " · HTTP " + _toDisplayString(attempt.response_status), 1))
                            : _createCommentVNode("", true),
                          (attempt.resent_by)
                            ? (_openBlock(), _createBlock("span", _hoisted_45, " · " + _toDisplayString(_ctx.$t('message.WMS_RESEND')) + " (" + _toDisplayString(attempt.resent_by) + ")", 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.log.result)
                  ? (_openBlock(), _createBlock("div", _hoisted_46, [
                      _createVNode("h4", _hoisted_47, _toDisplayString(_ctx.$t('message.WMS_BACKGROUND_RESULT')), 1),
                      _createVNode("pre", _hoisted_48, _toDisplayString(_ctx.pretty(_ctx.log.result)), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _createVNode("h4", _hoisted_51, _toDisplayString(_ctx.$t('message.WMS_REQUEST')), 1),
                    _createVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('message.WMS_HEADERS')), 1),
                    _createVNode("pre", _hoisted_53, _toDisplayString(_ctx.pretty(_ctx.log.request_headers)), 1),
                    _createVNode("pre", _hoisted_54, _toDisplayString(_ctx.pretty(_ctx.log.request_body) || _ctx.$t('message.NO_DATA_FOUND')), 1)
                  ]),
                  _createVNode("div", _hoisted_55, [
                    _createVNode("h4", _hoisted_56, _toDisplayString(_ctx.$t('message.WMS_RESPONSE')), 1),
                    _createVNode("pre", _hoisted_57, _toDisplayString(_ctx.pretty(_ctx.log.response_body) || _ctx.$t('message.NO_DATA_FOUND')), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.log?.can_resend)
            ? (_openBlock(), _createBlock("div", _hoisted_58, [
                _createVNode("button", {
                  class: "btn btn-warning",
                  type: "button",
                  disabled: !_ctx.wmsManagesProducts,
                  title: _ctx.wmsManagesProducts ? '' : _ctx.$t('message.WMS_SYNC_DISABLED_WMS_OFF'),
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.resend(_ctx.log.id)))
                }, [
                  _hoisted_59,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('message.WMS_RESEND')), 1)
                ], 8, ["disabled", "title"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})